import type { FC } from 'react';
import React from 'react';

import { withBemMod } from '@bem-react/core';

import type { IconProps } from './Icon';
import { cnIcon } from './Icon.cn';

import './_glyph/Icon_glyph.css';

type BaseIconProps = { sizeManagement?: 'self' | 'parent' };

/**
 * @deprecated используйте createIcon для создания иконок
 */
export const withIcon = <TGlyph extends string>(glyph: TGlyph, Svg: FC) =>
    withBemMod<BaseIconProps & { glyph?: typeof glyph }, IconProps>(cnIcon(), { glyph }, (Icon) => {
        const Component: typeof Icon = ({ className, sizeManagement = 'self', ...props }) => {
            return (
                <Icon
                    {...props}
                    className={cnIcon({ hasGlyph: 'noFill', oldFormat: true, sizeManagement }, [
                        className,
                    ])}
                >
                    <Svg />
                </Icon>
            );
        };

        Component.displayName = glyph;

        return Component;
    });
